export const AUDIT_LOGS_SECTION_EVENT = 'canvas-agent:audit-logs:section';
export const SNAPSHOT_HISTORY_SECTION_EVENT =
	'canvas-agent:snapshot-history:section';
export const SYSTEM_LOGS_SECTION_EVENT = 'canvas-agent:system-logs:section';
export const AUDIT_LOGS_FILTER_EVENT = 'canvas-agent:audit-logs:filter';
export const AUDIT_LOGS_FOCUS_EVENT = 'canvas-agent:audit-logs:focus';
export const AUDIT_LOGS_FILTER_MODAL_EVENT =
	'canvas-agent:audit-logs:filter-modal';
export const AUDIT_LOGS_VIEW_MORE_MODAL_EVENT =
	'canvas-agent:audit-logs:view-more-modal';
export const SNAPSHOT_HISTORY_FILTER_EVENT =
	'canvas-agent:snapshot-history:filter';
